import { Card } from 'primereact/card'
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Panel } from 'primereact/panel';
import { RadioButton } from 'primereact/radiobutton'
import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { getCountry, fetchlanguage } from '../reduxactions/doctoractions/DoctorProfileActions';
import { getSickness, getSpeciality } from '../reduxactions/suprivisoractions/SupDoctorsActions';
import { fetchAppointmentsData, fetchCloseCases, fetchOpenCases } from '../reduxactions/patientactions/PatientCasesActions';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { fetchApplication, fetchHospitalData } from '../reduxactions/patientactions/NewCaseActions';
import { PATIENT_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';


export const PatientNewApplications = () => {
  const uid = window.sessionStorage.getItem('uid');
  const usertype = window.sessionStorage.getItem('usertype');

  const [globalFilter, setGlobalFilter] = useState('');
  const [applicationType, setApplicationType] = useState('Aarogyasri');
  const [language, setLanguage] = useState('');
  const [caseName, setCaseName] = useState('');
  const [country, setCountry] = useState('');
  const [sickdesc, setSickDesc] = useState('');
  const [SpecilityName, setSpeciality] = useState('');
  const [hospital, setHospital] = useState('');
  const [sickness, setSickness] = useState('');
  const [application, setApplication] = useState('');
  const [state, setState] = useState('');

  // input feilds
  const [healthcardNo, setHealthCardNo] = useState('');
  const [idtype, setIdType] = useState('');
  const [IdCardNo, setIdCardNo] = useState('');
  const [Description, setDescription] = useState('');
  const [SelectCase, setSelectCase] = useState('');
  const [hospitlname, setHospitalname] = useState('');
  const [doctorname, setDocName] = useState('');
  const [regions, setRegions] = useState('');


  const countrydata = useSelector((state: RootState) => state.doctorprofile.country);
  const dispatch = useDispatch();
  const IdCardList = [
    { label: 'Voter ID', value: 'Voter ID' },
    { label: 'Driving Licence', value: 'Driving Licence' },
    { label: 'Pan Card', value: 'Pan Card' },
    { label: 'Aadhar Card', value: 'Aadhar Card' },
  ];

  useEffectOnce(() => {
    const fetchcountry = async () => {
      try {
        await dispatch(getCountry() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchcountry();
  }, [dispatch]);

  const lang = useSelector((state: RootState) => state.doctorprofile.lan);
  useEffectOnce(() => {
    const fetchLangData = async () => {
      try {
        await dispatch(fetchlanguage() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchLangData();
  }, [dispatch]);
  const specialitysss = useSelector((state: RootState) => state.sdoctorss.sick);
  console.log("specialitysss", specialitysss)
  useEffectOnce(() => {
    const FetchSpeciality = async () => {
      try {
        await dispatch(getSickness(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    FetchSpeciality();
  }, [dispatch]);
  const hospdata = useSelector((state: RootState) => state.newcase.hospital);
  useEffectOnce(() => {
    const FetchHoso = async () => {
      try {
        await dispatch(fetchHospitalData() as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    FetchHoso();
  }, [dispatch]);
  const [userData, setUserData] = useState<[]>([]);

  const fetchSickness = async (SpecilityID: any) => {
    try {
      const payload = { specility: SpecilityID };
      const apiname = PATIENT_API.sickness_API;
      const response = await LoginService.getData(apiname, payload);
      setUserData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [statedatas, setStateData] = useState<[]>([]);

  const fetchState = async (country: any) => {
    try {
      const payload = { countryId: country, q: 1 };
      const apiname = PATIENT_API.state_API;
      const response = await LoginService.getData(apiname, payload);
      setStateData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [hosplist, setHospList] = useState<[]>([]);

  const fetchHospList = async (state: any) => {
    try {
      const payload = { country: country, state: state };
      const apiname = PATIENT_API.hospitalList_API;
      const response = await LoginService.getData(apiname, payload);
      setHospList(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [regionsdatas, setRegionsData] = useState<[]>([]);

  const fetchRegions = async () => {
    try {
      const payload = { uid: uid };
      const apiname = PATIENT_API.regionsdata_API;
      const response = await LoginService.getData(apiname, payload);
      setRegionsData(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [doctornames, setDoctornames] = useState<[]>([]);

  const fetchDocData = async (hospitlname: any) => {
    try {
      const payload = { selhsptl: hospitlname };
      const apiname = PATIENT_API.doctordata_API;
      const response = await LoginService.getData(apiname, payload);
      setDoctornames(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [opencases, setOpenCases] = useState<[]>([]);

  const fetchOpenCasesList = async () => {
    try {
      const payload = { userid: uid };
      const apiname = PATIENT_API.opencases_APIAPP;
      const response = await LoginService.getData(apiname, payload);
      setOpenCases(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const applicationdata = useSelector((state: RootState) => state.newcase.application);
  useEffectOnce(() => {
    const fetchApp = async () => {
      try {
        await dispatch(fetchApplication(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchApp();
    fetchOpenCasesList();
    fetchRegions();
  }, [dispatch]);
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);
  const ApplyApplications = async () => {
    if (
      !healthcardNo || !country || !Description || !doctorname || !idtype ||
      !regions || !state || !hospitlname || !sickness || !uid
    ) {
      if (toast.current) {
        toast.current.show({ severity: 'error', detail: 'Please enter all fields.' });
      }
      return;
    }
    try {
      const payload = { cardnumber: healthcardNo, cnid: country, description: Description, doctorname: doctorname, health: healthcardNo, idcard: idtype, reg: regions, selectedstate: state, selhsptl: hospitlname, sick: sickness, uid: uid };
      const apiname = PATIENT_API.applyapplication_API;
      const response = await LoginService.getData(apiname, payload);
      setTimeout(() => {
        if (toast.current) {
          toast.current.show({ severity: 'success', detail: response });
        }
      }, 3000)
      setTimeout(() => {
        navigate('/patientapplications');
      }, 5000)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const uniqueSickness = specialitysss.filter(
  (item: any, index: number, self: any[]) =>
    index === self.findIndex((t) => t.Sickness === item.Sickness)
);


  // medical insurence 
  const [employename, setEmpName] = useState('');
  const [employeID, setEmployeID] = useState('');
  const [relation, setRelation] = useState('');


  const RelationList = [
    { label: 'Father', value: 'Father' },
    { label: 'Mother', value: 'Mother' },
    { label: 'Son', value: 'Son' },
    { label: 'Daughter', value: 'Daughter' },
    { label: 'Wife', value: 'Wife' },

  ];
  const toast1 = useRef<Toast>(null);
  const ApplyApplications1 = async () => {
    if (
      !healthcardNo || !country || !Description || !doctorname || !employename || !employeID || !relation || !idtype || !regions || !state || !hospitlname || !sickness) {
      if (toast.current) {
        toast.current.show({ severity: 'error', detail: 'Please enter all fields.' });
      }
      return;
    }
    try {
      const payload = { cardnumber: healthcardNo, cnid: country, employeename: employename, employeeid: employeID, nameId: relation, description: Description, doctorname: doctorname, health: healthcardNo, idcard: idtype, reg: regions, selectedstate: state, selhsptl: hospitlname, sick: sickness, uid: uid };
      const apiname = PATIENT_API.applyApplication_API;
      const response = await LoginService.getData(apiname, payload);
      setTimeout(() => {
        if (toast.current) {
          toast.current.show({ severity: 'success', detail: response });
        }
      }, 3000)
      setTimeout(() => {
        navigate('/patientapplications');
      }, 5000)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/patientnewapplications.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
                <div className="grid mb-2">
                  <div className="col-9">
                    <h1>New Case</h1>
                  </div>
                  <div className="col-3">
                    <a
                      title="help"
                      onClick={(e) => openWindow(e, IUrl)}
                      style={{

                        color: "blue",
                        fontSize: 15, cursor: "pointer"
                      }}
                    >Help for this Page &nbsp;
                      <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                    </a>
                  </div>
                </div>
              </div>
            </section>
            <section className="content">
              <div className="container-fluid">
                <div className="grid">
                  <div className="col-12">
                    <Card>
                      <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ marginRight: '10px' }}>Show:</label>
                        <div className="flex flex-wrap gap-3">
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="coronaCase"
                              name="caseType"
                              value="Aarogyasri"
                              onChange={(e) => setApplicationType(e.value)}
                              checked={applicationType === 'Aarogyasri'}
                            />
                            <label htmlFor="coronaCase" className="ml-2">Aarogyasri</label>
                          </div>
                          <div className="flex align-items-center">
                            <RadioButton
                              inputId="normalCase"
                              name="caseType"
                              value="Insurance"
                              onChange={(e) => setApplicationType(e.value)}
                              checked={applicationType === 'Insurance'}
                            />
                            <label htmlFor="normalCase" className="ml-2">Medical Insurance</label>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
                {applicationType === 'Aarogyasri' && (
                  <>
                    <Panel header="Enter Application Details" style={{ marginTop: '20px' }} toggleable>
                      <div className='grid'>
                        <div className="col-6">
                          {/* healthcardNo */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="fname" className="block text-900 font-medium ">Health Card Number</label>
                          </div>
                          <div className="col-3">
                            <InputText id="phone" placeholder="Enter Health Card Number" value={healthcardNo} onChange={(e) => setHealthCardNo(e.target.value)} style={{ width: '400px' }} />
                          </div>
                          {/* sickess */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="email" className="block text-900 font-medium ">Sickness</label>
                          </div>
                          <div className="col-3">
                           <Dropdown
  value={sickness}
  onChange={(e: DropdownChangeEvent) => setSickness(e.value)}
  options={uniqueSickness}
  optionLabel="Sickness"
  optionValue="SickID"
  placeholder="Select Sickness"
  style={{ width: '400px' }}
/>

                          </div>
                          {/* Description */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="email" className="block text-900 font-medium ">Description</label>
                          </div>
                          <div className="col-3">
                            <InputTextarea id="phone" placeholder="Enter Sickness Description" value={Description} onChange={(e) => setDescription(e.target.value)} style={{ width: '400px' }} />
                          </div>
                        </div>
                        <div className="col-6">
                          {/* id card type */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">ID Card Type</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={idtype} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setIdType(e.value)} options={IdCardList} optionLabel="label" optionValue="value" placeholder="Select Card" style={{ width: '400px' }} />
                          </div>
                          {/* Id Card No */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="fname" className="block text-900 font-medium ">Id Card Number</label>
                          </div>
                          <div className="col-3">
                            <InputText id="phone" placeholder="Enter Id Card Number" value={IdCardNo} onChange={(e) => setIdCardNo(e.target.value)} style={{ width: '400px' }} />
                          </div>
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">Select Case</label>
                          </div>
                          <div className="col-3">
                               <Dropdown
  value={sickness}
  onChange={(e: DropdownChangeEvent) => setSickness(e.value)}
  options={uniqueSickness}
  optionLabel="Sickness"
  optionValue="SickID"
  placeholder="Select Sickness"
  style={{ width: '400px' }}
/>
                          </div>

                        </div>
                      </div>
                    </Panel>
                    <Panel header="Select Preferred Details" style={{ marginTop: '20px' }} toggleable>
                      <div className='grid'>
                        <div className="col-6">
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">Country</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={country} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => { fetchState(e.value); setCountry(e.value) }} options={countrydata} optionLabel="name" optionValue="countryids" placeholder="Select Country" style={{ width: '400px' }} />
                          </div>
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">Hospital Name</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={hospitlname} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => { fetchDocData(e.value); setHospitalname(e.value) }} options={hosplist} optionLabel="hospitalname" optionValue="hospitalID" placeholder="Select Hospital" style={{ width: '400px' }} />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">State</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={state} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => { fetchHospList(e.value); setState(e.value) }} options={statedatas} optionLabel="name" optionValue="id" placeholder="Select State" style={{ width: '400px' }} />
                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                              <label htmlFor="lname" className="block text-900 font-medium">Doctor Name</label>
                            </div>
                            <div className="col-3">
                              <Dropdown id="country" value={doctorname} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setDocName(e.value)} options={doctornames} optionLabel="FirstName" optionValue="DoctorID" placeholder="Select Doctor Name" style={{ width: '400px' }} />
                            </div>
                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                              <label htmlFor="lname" className="block text-900 font-medium">Regions</label>
                            </div>
                            <div className="col-3">
                              <Dropdown id="country" value={regions} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setRegions(e.value)} options={regionsdatas} optionLabel="region_name" optionValue="region_ID" placeholder="Select Region" style={{ width: '400px' }} />
                            </div>
                          </div>

                        </div>
                      </div>
                    </Panel>
                    <div className="col-12 card-footer">
                      <Button label="Submit" style={{ marginLeft: '35px' }} onClick={ApplyApplications} />
                    </div>
                  </>
                )}

                {applicationType === 'Insurance' && (
                  <>
                    <Panel header="Employee Details" style={{ marginTop: '20px' }} toggleable>
                      <div className="grid">
                        <div className="col-4">
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <label htmlFor="language" className="block text-900 font-medium mb-2">Employee Name</label>
                            <InputText id="phone" placeholder="Enter Employee Name" value={employename} onChange={(e) => setEmpName(e.target.value)} style={{ width: '350px' }} />
                          </div>
                        </div>

                        {/* Country Label and Dropdown */}
                        <div className="col-4">
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <label htmlFor="country" className="block text-900 font-medium mb-2">Employee ID</label>
                            <InputText id="phone" placeholder="Enter Employee ID" value={employeID} onChange={(e) => setEmployeID(e.target.value)} style={{ width: '350px' }} />
                          </div>
                        </div>

                        {/* Speciality Label and Dropdown */}
                        <div className="col-4">
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <label htmlFor="speciality" className="block text-900 font-medium mb-2">Relation</label>
                            <Dropdown id="speciality" value={relation} onChange={(e: DropdownChangeEvent) => setRelation(e.value)} options={RelationList} optionLabel="label" optionValue="value" placeholder="Select Relative" className="custom-dropdown-placeholder" style={{ width: '100%' }}
                            />
                          </div>
                        </div>
                      </div>
                    </Panel>


                    <Panel header="Enter Application Details" style={{ marginTop: '20px' }} toggleable>
                      <div className='grid'>
                        <div className="col-6">
                          {/* healthcardNo */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="fname" className="block text-900 font-medium ">Health Card Number</label>
                          </div>
                          <div className="col-3">
                            <InputText id="phone" placeholder="Enter Health Card Number" value={healthcardNo} onChange={(e) => setHealthCardNo(e.target.value)} style={{ width: '400px' }} />
                          </div>
                          {/* sickess */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="email" className="block text-900 font-medium ">Sickness</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={sickness} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setSickness(e.value)} options={specialitysss} optionLabel="Sickness" optionValue="SickID" placeholder="Select Sickness" style={{ width: '400px' }} />
                          </div>
                          {/* Description */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="email" className="block text-900 font-medium ">Description</label>
                          </div>
                          <div className="col-3">
                            <InputTextarea id="phone" placeholder="Enter Sickness Description" value={Description} onChange={(e) => setDescription(e.target.value)} style={{ width: '400px' }} />
                          </div>
                        </div>
                        <div className="col-6">
                          {/* id card type */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">ID Card Type</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={idtype} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setIdType(e.value)} options={IdCardList} optionLabel="label" optionValue="value" placeholder="Select Card" style={{ width: '400px' }} />
                          </div>
                          {/* Id Card No */}
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="fname" className="block text-900 font-medium ">Id Card Number</label>
                          </div>
                          <div className="col-3">
                            <InputText id="phone" placeholder="Enter Id Card Number" value={IdCardNo} onChange={(e) => setIdCardNo(e.target.value)} style={{ width: '400px' }} />
                          </div>
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">Select Case</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={caseName} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setCaseName(e.value)} options={opencases} optionLabel="Sickness" optionValue="Sickness" placeholder="Select Case" style={{ width: '400px' }} />
                          </div>

                        </div>
                      </div>
                    </Panel>
                    <Panel header="Select Preferred Details" style={{ marginTop: '20px' }} toggleable>
                      <div className='grid'>
                        <div className="col-6">
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">Country</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={country} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => { fetchState(e.value); setCountry(e.value) }} options={countrydata} optionLabel="name" optionValue="countryids" placeholder="Select Country" style={{ width: '400px' }} />
                          </div>
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">Hospital Name</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={hospitlname} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => { fetchDocData(e.value); setHospitalname(e.value) }} options={hosplist} optionLabel="hospitalname" optionValue="hospitalID" placeholder="Select Hospital" style={{ width: '400px' }} />
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                            <label htmlFor="lname" className="block text-900 font-medium">State</label>
                          </div>
                          <div className="col-3">
                            <Dropdown id="country" value={state} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => { fetchHospList(e.value); setState(e.value) }} options={statedatas} optionLabel="name" optionValue="id" placeholder="Select State" style={{ width: '400px' }} />
                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                              <label htmlFor="lname" className="block text-900 font-medium">Doctor Name</label>
                            </div>
                            <div className="col-3">
                              <Dropdown id="country" value={doctorname} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setDocName(e.value)} options={doctornames} optionLabel="FirstName" optionValue="DoctorID" placeholder="Select Doctor Name" style={{ width: '400px' }} />
                            </div>
                            <div className="col-3" style={{ display: 'flex', flex: 1, width: '200px' }}>
                              <label htmlFor="lname" className="block text-900 font-medium">Regions</label>
                            </div>
                            <div className="col-3">
                              <Dropdown id="country" value={regions} className="mb-3 custom-dropdown" onChange={(e: DropdownChangeEvent) => setRegions(e.value)} options={regionsdatas} optionLabel="region_name" optionValue="region_ID" placeholder="Select Region" style={{ width: '400px' }} />
                            </div>
                          </div>

                        </div>
                      </div>
                    </Panel>
                    <div className="col-12 card-footer">
                      <Button label="Submit" style={{ marginRight: '65px' }} onClick={ApplyApplications1} />
                    </div>
                  </>
                )}
              </div >
            </section >
          </div >
        </div>
        <Toast ref={toast1} ></Toast>
        <Toast ref={toast} ></Toast>

      </div>
    </div>
  )
}